import axios from "../../api/axios";
import { useAxios } from "../../utils/hooks/useAxios";

export const useAuth = () => {
  const { axiosProtected } = useAxios();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const login = (payload) =>
    axios.post("login", payload, {
      headers,
    });
  const logout = async () => {
    const res = await axiosProtected.post("logout");

    return res;
  };

  const getCurrentUser = async () => {
    const { data } = await axiosProtected("me");

    return data;
  };

  return { login, getCurrentUser, logout };
};
